import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Assuming you have this file, otherwise remove the line below if not needed
// import { useAuth } from '../../auth/useAuth'; 
import s from './LoginPage.module.css';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [view, setView] = useState('login'); // 'login' or 'forgot'
  const navigate = useNavigate();
  
  // Keeping the import, but overriding logic slightly for the demo requirement
  // const { login } = useAuth(); 

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    
    // Simulating Auth Logic based on your request
    const correctUser = "TheHexaPlaY";
    const correctPass = "thEhexAplaY";

    if (username === correctUser && password === correctPass) {
      // Success
      setError('');
      localStorage.setItem("isAuthenticated", "true");
      
      /**
       * Ensure Route for Pillar.jsx is set to '/Pillar' 
       */
      navigate('/Pillar', { replace: true });
    } else {
      // Fail
      setError('Invalid username or password. Please try again.');
      
      // Animation shake for feedback
      const form = document.getElementById('loginForm');
      if(form) {
        form.classList.add(s.shake);
        setTimeout(() => form.classList.remove(s.shake), 500);
      }
    }
  };

  return (
    <div className={s.wrapper}>
      {/* Background decorative shapes */}
      <div className={s.blob}></div>
      <div className={s.blob}></div>

      <div className={s.card}>
        <div className={s.cardHeader}>
          <h1 className={s.title}>Welcome Back</h1>
          <p className={s.subtitle}>Enter your credentials to access your account</p>
        </div>

        {view === 'login' ? (
          <form id="loginForm" onSubmit={handleLoginSubmit} className={s.form}>
            {error && <div className={s.errorBox}>{error}</div>}

            <div className={s.fieldGroup}>
              <label htmlFor="username" className={s.labelInput}>Username / Email</label>
              <div className={s.inputWrapper}>
                <svg className={s.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                <input
                  id="username"
                  className={s.inputField}
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="name@example.com"
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div className={s.fieldGroup}>
              <div className={s.labelRow}>
                <label htmlFor="password" className={s.labelInput}>Password</label>
              </div>
              <div className={s.inputWrapper}>
                <svg className={s.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                <input
                  id="password"
                  className={s.inputField}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button type="submit" className={s.btnPrimary}>Sign In</button>
            
            <div className={s.divider}>or</div>

            <button 
              type="button" 
              onClick={() => setView('forgot')} 
              className={s.linkButton}
            >
              Forgot Password?
            </button>
          </form>
        ) : (
          /* FORGOT PASSWORD VIEW */
          <div className={s.forgotContainer}>
            <div className={s.forgotIcon}>
               <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>
            </div>
            <h3 className={s.forgotTitle}>Lost Access?</h3>
            <p className={s.forgotText}>
              For security reasons, automated password resets aren't available. 
              Contact our admin support team directly via WhatsApp for immediate assistance.
            </p>
            
            <a 
              href="https://wa.me/917092471686?text=Hello%2C%20I%20have%20forgotten%20my%20password.%20Please%20help."
              target="_blank"
              rel="noopener noreferrer"
              className={s.whatsappBtn}
            >
              <span>Contact Support</span>
            </a>
            
            <button 
              type="button" 
              onClick={() => {
                setView('login');
                setError('');
                setUsername('');
                setPassword('');
              }} 
              className={s.backLink}
            >
              &larr; Back to Login
            </button>
          </div>
        )}

        <div className={s.footerText}>
          <p>Need help contact <a href="" target="_blank">Best Website development company in ponicherry</a></p>
          <p className={s.brandName}>by Adlink Web Services</p>
        </div>
      </div>
    </div>
  );
}